import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { palette } from '../styles';
import * as darkPalette from '../styles/darkPalette';
import * as sharefilePalette from '../styles/sharefilePalette';
export var PaletteName;
(function (PaletteName) {
  PaletteName["citrixbrand"] = "citrixbrand";
  PaletteName["neutral"] = "neutral";
  PaletteName["darkcitrixbrand"] = "darkcitrixbrand";
  PaletteName["sharefilebrand"] = "sharefilebrand";
})(PaletteName || (PaletteName = {}));
export var ThemeColor;
(function (ThemeColor) {
  ThemeColor["primary"] = "primary";
  ThemeColor["action"] = "action";
  ThemeColor["actionHover"] = "actionHover";
  ThemeColor["secondaryActionIcon"] = "secondaryActionIcon";
  ThemeColor["focus"] = "focus";
  ThemeColor["inputBorder"] = "inputBorder";
  ThemeColor["inputBackground"] = "inputBackground";
  ThemeColor["inputHoverBorder"] = "inputHoverBorder";
  ThemeColor["errorBorder"] = "errorBorder";
  ThemeColor["errorBackground"] = "errorBackground";
  ThemeColor["warningBorder"] = "warningBorder";
  ThemeColor["warningBackground"] = "warningBackground";
  ThemeColor["successBorder"] = "successBorder";
  ThemeColor["successBackground"] = "successBackground";
  ThemeColor["infoBorder"] = "infoBorder";
  ThemeColor["infoBackground"] = "infoBackground";
  ThemeColor["modalBackground"] = "modalBackground";
  ThemeColor["bladeBackground"] = "bladeBackground";
  ThemeColor["flyoverBackground"] = "flyoverBackground";
  ThemeColor["listItemHoverBackground"] = "listItemHoverBackground";
  ThemeColor["listItemSelectedBackground"] = "listItemSelectedBackground";
  ThemeColor["primaryText"] = "primaryText";
  ThemeColor["secondaryText"] = "secondaryText";
  ThemeColor["metadataText"] = "metadataText";
  ThemeColor["border"] = "border";
  ThemeColor["primaryAppBackground"] = "primaryAppBackground";
  ThemeColor["primaryContainerBackground"] = "primaryContainerBackground";
  ThemeColor["secondaryAppBackground"] = "secondaryAppBackground";
  ThemeColor["secondaryContainerBackground"] = "secondaryContainerBackground";
  ThemeColor["activeTab"] = "activeTab";
  ThemeColor["accentColor"] = "accentColor";
})(ThemeColor || (ThemeColor = {}));
// Colors shared between the citrixbrand and neutral themes
var baseTheme = {
  secondaryActionIcon: palette.grey800,
  focus: palette.purple800,
  inputBorder: palette.grey500,
  inputBackground: palette.white,
  inputHoverBorder: palette.grey900,
  errorBorder: palette.red900,
  errorBackground: palette.red100,
  warningBorder: palette.orange800,
  warningBackground: palette.orange100,
  successBorder: palette.green900,
  successBackground: palette.green100,
  infoBorder: palette.blue800,
  infoBackground: palette.blue100,
  modalBackground: palette.white,
  bladeBackground: palette.white,
  flyoverBackground: palette.white,
  listItemHoverBackground: palette.grey200,
  primaryText: palette.grey900,
  secondaryText: palette.grey800,
  metadataText: palette.grey700,
  border: palette.grey300,
  primaryAppBackground: palette.grey100,
  primaryContainerBackground: palette.white,
  secondaryAppBackground: palette.white,
  secondaryContainerBackground: palette.grey100
};
var citrixBrandTheme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  primary: palette.teal700,
  action: palette.teal700,
  actionHover: palette.teal800,
  listItemSelectedBackground: palette.teal100,
  activeTab: palette.teal700,
  accentColor: palette.teal700
});
var neutralTheme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  primary: palette.blue800,
  action: palette.blue800,
  actionHover: palette.blue900,
  listItemSelectedBackground: palette.blue100,
  activeTab: palette.blue800,
  accentColor: palette.blue800
});
var darkCitrixBrandTheme = {
  primary: darkPalette.teal,
  action: darkPalette.teal,
  actionHover: darkPalette.tealHover,
  secondaryActionIcon: palette.grey100,
  focus: darkPalette.purple,
  inputBorder: palette.grey500,
  inputBackground: darkPalette.grey800,
  inputHoverBorder: palette.grey100,
  errorBorder: darkPalette.red,
  errorBackground: darkPalette.redAlert,
  warningBorder: darkPalette.orange,
  warningBackground: darkPalette.orangeAlert,
  successBorder: darkPalette.green,
  successBackground: darkPalette.greenAlert,
  infoBorder: darkPalette.blue,
  infoBackground: darkPalette.blueAlert,
  modalBackground: darkPalette.grey800,
  bladeBackground: darkPalette.grey800,
  flyoverBackground: darkPalette.grey400,
  listItemHoverBackground: darkPalette.grey300,
  listItemSelectedBackground: darkPalette.tealSelected,
  primaryText: darkPalette.grey100,
  secondaryText: darkPalette.grey500,
  metadataText: darkPalette.grey500,
  border: darkPalette.grey500,
  primaryAppBackground: darkPalette.grey900,
  primaryContainerBackground: darkPalette.grey800,
  secondaryAppBackground: palette.grey900,
  secondaryContainerBackground: darkPalette.grey800,
  activeTab: darkPalette.teal,
  accentColor: darkPalette.teal
};
var sharefileBrandTheme = {
  primary: sharefilePalette.greydark900,
  activeTab: sharefilePalette.lavender300,
  action: sharefilePalette.lavender300,
  actionHover: sharefilePalette.lavender400,
  secondaryActionIcon: sharefilePalette.greydark300,
  focus: sharefilePalette.pink300,
  inputBorder: sharefilePalette.greylight700,
  inputBackground: sharefilePalette.greylight100,
  inputHoverBorder: sharefilePalette.greydark900,
  errorBorder: sharefilePalette.red300,
  errorBackground: sharefilePalette.red100,
  warningBorder: sharefilePalette.orange300,
  warningBackground: sharefilePalette.orange100,
  successBorder: sharefilePalette.green300,
  successBackground: sharefilePalette.green100,
  infoBorder: sharefilePalette.blue400,
  infoBackground: sharefilePalette.blue100,
  modalBackground: sharefilePalette.greylight100,
  bladeBackground: sharefilePalette.greylight100,
  flyoverBackground: sharefilePalette.greylight100,
  listItemHoverBackground: sharefilePalette.greylight300,
  listItemSelectedBackground: sharefilePalette.lavender50,
  primaryText: sharefilePalette.greydark900,
  secondaryText: sharefilePalette.greydark400,
  metadataText: sharefilePalette.greydark300,
  border: sharefilePalette.greylight300,
  primaryAppBackground: sharefilePalette.greylight200,
  primaryContainerBackground: sharefilePalette.greylight100,
  secondaryAppBackground: sharefilePalette.greylight100,
  secondaryContainerBackground: sharefilePalette.greylight200,
  accentColor: sharefilePalette.lavender300
};
export function getThemeColors(paletteName) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme;
  switch (paletteName) {
    case PaletteName.citrixbrand:
      theme = citrixBrandTheme;
      break;
    case PaletteName.darkcitrixbrand:
      theme = darkCitrixBrandTheme;
      break;
    case PaletteName.sharefilebrand:
      theme = sharefileBrandTheme;
      break;
    case PaletteName.neutral:
    default:
      theme = neutralTheme;
  }
  var filteredOverrides = {};
  Object.entries(overrides).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value && typeof value === 'string') {
      filteredOverrides[key] = value;
    }
  });
  return _objectSpread(_objectSpread({}, theme), filteredOverrides);
}